import { getConfiguredValue } from 'js/mapProviderConfig';

const bingMapsApiKey = getConfiguredValue('bingMapsApiKey');
const mapBoxAccessToken = getConfiguredValue('mapboxAccessToken');
const cesiumIonAccessToken = getConfiguredValue('cesiumIonAccessToken');

function applyCesiumProviderTokens(cesium) {
    if (bingMapsApiKey) {
        cesium.BingMapsImageryProvider.defaultKey = bingMapsApiKey;
    }
    if (mapBoxAccessToken) {
        cesium.MapboxImageryProvider.defaultAccessToken = mapBoxAccessToken;
    }
    if (cesiumIonAccessToken) {
        cesium.Ion.defaultAccessToken = cesiumIonAccessToken;
    }
}

export {
    applyCesiumProviderTokens,
    bingMapsApiKey,
    cesiumIonAccessToken,
    mapBoxAccessToken,
};
